/* tslint:disable */
/* eslint-disable */
/**
 * DynamicForms.Server | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { StrapiBlockFromJSON, StrapiBlockToJSON, } from './StrapiBlock';
/**
 * Check if a given object implements the AnswerComponent interface.
 */
export function instanceOfAnswerComponent(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    return true;
}
export function AnswerComponentFromJSON(json) {
    return AnswerComponentFromJSONTyped(json, false);
}
export function AnswerComponentFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'text': json['text'] == null ? undefined : (json['text'].map(StrapiBlockFromJSON)),
    };
}
export function AnswerComponentToJSON(json) {
    return AnswerComponentToJSONTyped(json, false);
}
export function AnswerComponentToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'text': value['text'] == null ? undefined : (value['text'].map(StrapiBlockToJSON)),
    };
}
